import {
  ESTRATEGIA_RETRY_PADRAO,
  FalhaHttp,
  type ClienteHttp,
} from '@next/infraestrutura/http'

import type { OpcaoRegraDeCalculo } from '../catalogo-regra-de-calculo.tipos'

const ENDPOINT = '/custom'
const CAMPOS = [
  'id',
  'name',
  'code',
  'calculo_passivo',
] as const

export class ListarOpcoesRegraDeCalculoRepositorioHttp {
  constructor(private readonly http: ClienteHttp) {}

  executar = async (
    sinal: AbortSignal,
  ): Promise<readonly OpcaoRegraDeCalculo[]> => {
    const resposta = await this.http.get<unknown>(ENDPOINT, {
      parametros: { fields: JSON.stringify(CAMPOS) },
      signal: sinal,
      retry: ESTRATEGIA_RETRY_PADRAO,
    })

    const dados = resposta.data
    if (resposta.status === 204) return []
    if (typeof dados === 'object' && dados !== null) {
      if ('success' in dados && Array.isArray(dados.success)) {
        return dados.success.flatMap((item: unknown) => {
          if (typeof item !== 'object' || item === null || Array.isArray(item)) return []
          const registro = item as Record<string, unknown>
          return [Object.fromEntries(['id', 'name', 'code', 'calculoPassivo']
            .filter(campo => Object.prototype.hasOwnProperty.call(registro, campo))
            .map(campo => [campo, registro[campo]])) as OpcaoRegraDeCalculo]
        })
      }
      if ('no-data' in dados) return []
    }
    throw new FalhaHttp({
      tipo: 'resposta_invalida',
      servico: 'condominio',
      metodo: 'GET',
      endpoint: ENDPOINT,
      status: resposta.status,
      causa: dados,
      ...(resposta.requestId ? { requestId: resposta.requestId } : {}),
    })
  }
}
